<template>
    <fleetmanager-dashboard-layout id="fdb-page" class="h-100">
        <h1 v-if="coreCompanyName" class="mb-5">Fleetmanager / {{ coreCompanyName }}</h1>
        <h1 v-else class="mb-5">Fleetmanager / {{ $t('fdb.no_company.selected.text') }}</h1>
        <b-tabs v-model="activeTab" content-class="py-5" v-if="!isLoading">
            <b-tab :title="$t('fdb.tab.dashboard')" @click="setActiveTab(0)">
                <fdb-tab-dashboard 
                    @setTab="setActiveTab"
                ></fdb-tab-dashboard>
            </b-tab>
            <b-tab :title="$t('fdb.tab.drivers')" @click="setActiveTab(1)">
                <fdb-tab-drivers
                    @setTab="setActiveTab"
                    @setSubscriptionsEmailFilter="setSubscriptionsEmailFilter"
                ></fdb-tab-drivers>
            </b-tab>
            <b-tab :title="$t('fdb.tab.subscriptions')" @click="setActiveTab(2)">
                <fdb-tab-subscriptions 
                    @setTab="setActiveTab"
                    :defaultEmailFilter="subscriptionsEmailFilter"
                ></fdb-tab-subscriptions>
            </b-tab>
        </b-tabs>
    </fleetmanager-dashboard-layout>
</template>

<script>
import FleetmanagerDashboardLayout from '../../layouts/FleetmanagerDashboardLayout.vue'
import FdbTabDashboard from '../../components/organisms/FdbTabDashboard.vue'
import FdbTabDrivers from '../../components/organisms/FdbTabDrivers.vue'
import FdbTabSubscriptions from '../../components/organisms/FdbTabSubscriptions.vue'
import FdbTabInvoices from '../../components/organisms/FdbTabInvoices.vue'
import { BTabs, BTab } from 'bootstrap-vue'

export default {
    components: {
        FleetmanagerDashboardLayout,
        BTabs, BTab,
        FdbTabDrivers, FdbTabSubscriptions, FdbTabInvoices, FdbTabDashboard
    },
    data() {
        return {
            activeTab: 0,
            subscriptionsEmailFilter: '',
            isLoading: true,
            selectedCompany: JSON.parse(localStorage.getItem('selectedCompany'))
        }
    },
    methods: {
        mountActiveTab() {
            if(this.$route.query.tab) {
                this.activeTab = Number(this.$route.query.tab)
            }
            this.isLoading = false
        },
        setActiveTab(index) {
            this.activeTab = index
            this.$router.replace({query: { tab: index }})
        },
        setSubscriptionsEmailFilter(email) {
            this.subscriptionsEmailFilter = email
        }
    },
    mounted() {
        if (this.$root.user?.state?.data?.core_user?.fleetmanager?.status === 'inactive') {
            this.$goTo('catalog')
        }
        this.mountActiveTab()
    },
    computed: {
        coreCompanyName() {
            return this.selectedCompany.name ?? ''
        }
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.fleetmanager-dashboard.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.fleetmanager-dashboard.description') }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    input, .b-form-datepicker label {
        background: #f7f7f7 !important;
        border: 0;
        font-weight: bold;
        padding: 14px 20px;
    }
    .custom-select {
        background-color: #f7f7f7 !important;
        border: 0;
    }
    .b-form-datepicker {
        height: calc(1.5em + 0.75rem + 2px) !important;
        border: 0;
        button {
            background: #f7f7f7 !important;
        }
        .text-muted {
            color: #d9d9d9 !important;
            padding-top: 6px;
        }
        label {
            padding: 0.375rem 0.75rem;
        }
    }
}

::v-deep .fdb-table {
    background: #F8F8F8;
    td, th {
        padding: 32px;
    }
    th {
        font-weight: bold;
        color: #7e7e7e;
    }
}
</style>
